import util from 'util';
import { CONSTANT } from '@const';
import { WaterAccountType } from '@types';

import { ApiParams, ApiService } from '../api/ApiService';

export class WaterAccountService extends ApiService {
	static async getWaterAccounts(clientId: string): Promise<WaterAccountType[]> {
		const params: ApiParams = {
			method: 'GET',
			url: util.format(`${CONSTANT.WATER_ACCOUNTS_API_URL}`, clientId),
		};
		return await this.executeApiRequest(params).then(data =>
			this.sortAssociatedListsByReference(data),
		);
	}

	static async updateWaterAccount(
		clientId: string,
		waterAccountId: string,
		name: string,
	): Promise<WaterAccountType> {
		const params: ApiParams = {
			method: 'PUT',
			url: util.format(CONSTANT.WATER_ACCOUNTS_UPDATE_API_URL, clientId, waterAccountId),
			data: { name: name },
		};
		return await this.executeApiRequest(params);
	}

	private static sortAssociatedListsByReference(waterAccounts: WaterAccountType[]) {
		return waterAccounts.map(waterAccount => {
			waterAccount.devices = waterAccount.devices.sort((a, b) =>
				a.reference.localeCompare(b.reference),
			);
			waterAccount.works = waterAccount.works.sort((a, b) =>
				a.reference.localeCompare(b.reference),
			);
			return waterAccount;
		});
	}
}
